import { createRouter, createWebHistory } from 'vue-router'
import Reports from '../views/Reports.vue'
import Transactions from '../views/Transactions.vue'
import Accounts from '../views/Accounts.vue'
import Categories from '../views/Categories.vue'
import BillImport from '../views/BillImport.vue'
import AIAccounting from '../views/AIAccounting.vue'
import TransactionForm from '../components/TransactionForm.vue'
import Login from '../views/Login.vue'
import store from '../store'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresGuest: true }
  },
  {
    path: '/',
    redirect: '/reports'
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    redirect: '/reports',
    meta: { requiresAuth: true }
  },
  {
    path: '/reports',
    name: 'Reports',
    component: Reports,
    meta: { requiresAuth: true }
  },
  {
    path: '/transactions',
    name: 'Transactions',
    component: Transactions,
    meta: { requiresAuth: true }
  },
  {
    path: '/accounts',
    name: 'Accounts',
    component: Accounts,
    meta: { requiresAuth: true }
  },
  {
    path: '/categories',
    name: 'Categories',
    component: Categories,
    meta: { requiresAuth: true }
  },
  {
    path: '/imports',
    name: 'BillImport',
    component: BillImport,
    meta: { requiresAuth: true }
  },
  {
    path: '/transaction/new',
    name: 'NewTransaction',
    component: TransactionForm,
    meta: { requiresAuth: true }
  },
  {
    path: '/ai-accounting',
    redirect: '/transaction/new?mode=ai'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = store.state.isAuthenticated
  
  // 需要登录的页面
  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login')
    return
  }
  
  // 已登录用户访问登录页面
  if (to.meta.requiresGuest && isAuthenticated) {
    next('/')
    return
  }
  
  next()
})

export default router 
